export default __webpack_public_path__ + "static/Group55-3ce128e9686e9a6eb48fb086437c68d8.svg";